import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './GreetingUser.scss';
import AiLogo from '@/assets/icons/ai-logo.svg';

const GreetingUser = () => {
    const [seasonalMessage, setSeasonalMessage] = useState('');
    const userDetail = useSelector((state) => state.userDetail);
    const fullName = userDetail?.firstName || userDetail?.name || '';
    const firstName = fullName.trim().split(/\s+/)[0] || 'there';

    useEffect(() => {
        const month = new Date().getMonth();
        const monthMessages = {
            0: `❄️ January is a fresh start, and I’m here to make it even better. Let’s dive in—what can I help with today?`,
            1: `❤️ February is the month of love, and I’m here to assist with care. How can I make your day smoother?`,
            2: `🌸 March brings blossoms and possibilities. What would you like to tackle today?`,
            3: `🌼 April showers may come, but I’ll make sure your tasks are sunny. What’s on your mind?`,
            4: `☀️ May is perfect for new ideas and bright days. Let’s make it amazing—how can I assist?`,
            5: `🌊 June is the perfect time for making waves. What’s your next big splash?`,
            6: `🏖️ July vibes are all about relaxing and achieving. Let me know how I can help you!`,
            7: `🍉 August is full of summer sweetness. Let’s make your day just as sweet. How can I assist?`,
            8: `🍂 September brings crisp air and fresh goals. What’s the first thing on your list?`,
            9: `🎃 October is spooky good for productivity. Let’s conquer your tasks—what’s first?`,
            10: `🦃 November is a time for gratitude, and I’m thankful to help. What’s on your mind today?`,
            11: `🎅 December’s festive spirit is here. Let’s wrap up your goals like holiday gifts! What can I help with?`,
        };

        setSeasonalMessage(monthMessages[month] || `😊 How can I make your day special today?`);
    }, []);

    return (
        <div className="greeting-user">
            <img src={AiLogo} alt="Logo" className="logo" />
            <h2>Hello {firstName},</h2>
            <p className="prompt">{seasonalMessage}</p>
        </div>
    );
};

export default GreetingUser;
